const LOGO_URL = '/icon_infosoft.svg';

let logoPromise = null;

/** Precarga el logo en memoria del navegador (una sola vez por sesión). */
export function preloadLogo() {
    if (typeof window === 'undefined') {
        return Promise.resolve(null);
    }

    if (!logoPromise) {
        logoPromise = new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => resolve(null);
            img.src = LOGO_URL;
        });
    }

    return logoPromise;
}
